import { useMutation } from "@tanstack/react-query";
import { unAuthenticatedApiFetch } from "../APIClient";
import { CheckDuplicateEmailRequestDto } from "../generated/generatedTypes";

// interface CheckDuplicateEmailRequest {
//   email: string;
// }

const checkDuplicateEmail = async ({ email }: CheckDuplicateEmailRequestDto) => {
  const response = await unAuthenticatedApiFetch("api/users/email/check-duplicate", {
    method: "POST",
    body: JSON.stringify({ email }),
    headers: {
      "Content-Type": "application/json",
    },
  });

  if (!response.ok) {
    if (response.status === 409) {
      return { isDuplicate: true };
    }
    const error = await response.json();
    throw new Error(error?.message || "일시적인 오류가 발생했습니다. 잠시 후 다시 시도해주세요.");
  }

  // A 204 No Content response indicates no duplicate
  return { isDuplicate: false };
};

export function useCheckDuplicateEmail() {
  return useMutation<{ isDuplicate: boolean }, Error, CheckDuplicateEmailRequestDto>({
    mutationFn: checkDuplicateEmail,
  });
}
